import endpoints from "config/endpoints";
import { useMemo } from "react";
import useAxiosRequest from "./common/useAxiosRequest";

const useProfissoes = () => {
  const { data, loading, error } = useAxiosRequest({
    url: endpoints.profissoes(),
    method: "GET",
    autoRun: true,
  });

  const profissoes = useMemo(
    () =>
      data?.map(({ codigo, nome }) => ({
        id: codigo,
        value: nome,
      })),
    [data]
  );

  return { profissoes, loading, error };
};

export default useProfissoes;
